import { productFragmentNormal } from '../fragments'

/** A write precondition, never part of the row's optimistic business patch. */
export type ProductStatusUpdatePrecondition = {
  expectedUpdatedAt: string
}

/** Canonical server metadata returned by a confirmed conditional write. */
export type ProductStatusUpdateReceipt = {
  id: string
  updatedAt: string
}

export const getProductStatusQuery = /* GraphQL */ `
  query GetProductStatus($id: ID!) {
    getProductStatus(id: $id) {
      ...productStatus
    }
  }
  ${productFragmentNormal}
`

export const productByIDQuery = /* GraphQL */ `
  query productByID($productID: ID!) {
    productByID(productID: $productID) {
      items {
        ...productStatus
      }
    }
  }
  ${productFragmentNormal}
`

export const productsByUserQuery = /* GraphQL */ `
  query ProductsByUser(
    $byUserID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByUser(
      byUserID: $byUserID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...productStatus
        serialIDs
      }
      nextToken
    }
  }
  ${productFragmentNormal}
`

export const productsByOrganizationQuery = /* GraphQL */ `
  query ProductsByOrganization(
    $organizationID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByOrganization(
      organizationID: $organizationID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...productStatus
        serialIDs
      }
      nextToken
    }
  }
  ${productFragmentNormal}
`

export const productsByOrganizationProgressQuery = /* GraphQL */ `
  query ProductsByOrganizationProgress(
    $organizationID: ID!
    $progress: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByOrganizationProgress(
      organizationID: $organizationID
      progress: $progress
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...productStatus
        serialIDs
      }
      nextToken
    }
  }
  ${productFragmentNormal}
`

export const productsByOrganizationTypeQuery = /* GraphQL */ `
  query ProductsByOrganizationType(
    $organizationID: ID!
    $type: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByOrganizationType(
      organizationID: $organizationID
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...productStatus
        serialIDs
      }
      nextToken
    }
  }
  ${productFragmentNormal}
`

export const productsByMasterOrganizationQuery = /* GraphQL */ `
  query ProductsByMasterOrganization(
    $organizationMasterID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByMasterOrganization(
      organizationMasterID: $organizationMasterID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...productStatus
        serialIDs
      }
      nextToken
    }
  }
  ${productFragmentNormal}
`

export const productsByProjectQuery = /* GraphQL */ `
  query ProductsByProject(
    $projectID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByProject(
      projectID: $projectID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...productStatus
        serialIDs
      }
      nextToken
    }
  }
  ${productFragmentNormal}
`

export const productsByProjectProgressQuery = /* GraphQL */ `
  query ProductsByProjectProgress(
    $projectID: ID!
    $progress: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByProjectProgress(
      projectID: $projectID
      progress: $progress
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...productStatus
        serialIDs
      }
      nextToken
    }
  }
  ${productFragmentNormal}
`

export const productsByProjectTypeQuery = /* GraphQL */ `
  query ProductsByProjectType(
    $projectID: ID!
    $type: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByProjectType(
      projectID: $projectID
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...productStatus
        serialIDs
      }
      nextToken
    }
  }
  ${productFragmentNormal}
`

export const productsByShopQuery = /* GraphQL */ `
  query ProductsByShop(
    $shopID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByShop(
      shopID: $shopID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...productStatus
      }
      nextToken
    }
  }
  ${productFragmentNormal}
`
